export default __webpack_public_path__ + "static/media/released-for-rail.0bdabbe7.svg";